import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  text-align: center;
  flex-direction: column;
  align-items: center;
  height: 100vh;
  width: 100vw;

  .buttonWrapper {
    margin-top: 10px;
  }
`;
